import { Button, styled } from '@moleculeone/ui';

import Toolbar from '@f/components/shared/toolbar/Toolbar';

const ResultsNavigationContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export function ResultsNavigation({ goToPreviousResult, goToNextResult, currentIndex, resultsLength }) {
  if (resultsLength === 0) {
    return null;
  }
  return (
    <ResultsNavigationContainer>
      <Toolbar.Item>
        <Button
          text="Prev"
          onClick={goToPreviousResult}
          disabled={currentIndex === 0}
          icon="chevron_left"
          weight="minimal"
          size="small"
        />
      </Toolbar.Item>
      <Toolbar.Item>
        {currentIndex + 1} of {resultsLength}
      </Toolbar.Item>
      <Toolbar.Item>
        <Button
          text="Next"
          onClick={goToNextResult}
          disabled={currentIndex === resultsLength - 1}
          rightIcon="chevron_right"
          weight="minimal"
          size="small"
        />
      </Toolbar.Item>
    </ResultsNavigationContainer>
  );
}
